function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import l from "../util/net.js";
import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import c from "../common/event-logger.js";
import { newInAppMessageFromJson as ut } from "./in-app-message-factory.js";
import { randomInclusive as a } from "../util/math.js";
import E from "../models/request-result.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import u from "../managers/subscription-manager.js";
import pt from "../triggers/models/trigger.js";
import { BRAZE_ACTION_URI_REGEX as to } from "../util/validation-utils.js";
import { containsPushPrimerBrazeAction as gt, containsUnknownBrazeAction as ft, getDecodedBrazeAction as eo, ineligibleBrazeActionURLErrorMessage as jt, INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as vt } from "../util/braze-actions.js";
import yt from "../Push/utils/push-utils.js";
import h from "../util/request-header-utils.js";
import { STORAGE_KEYS as t } from "../managers/storage-manager.js";
import { FullScreenMessage, ModalMessage, SlideUpMessage } from "./index.js";

var ea = /*#__PURE__*/function () {
  function ea(t, e, s, i) {
    _classCallCheck(this, ea);

    this.S = t, this.T = e, this.C = s, this.As = i, this.S = t, this.T = e, this.C = s, this.As = i, this.Ir = new u(), r.N(this.Ir), this.Mr = 1e3, this.Tr = 6e4, this.Br = null;
  }

  _createClass(ea, [{
    key: "_r",
    value: function _r() {
      return this.Ir;
    }
  }, {
    key: "qr",
    value: function qr(t) {
      return this.Ir.Ns(t);
    }
  }, {
    key: "Er",
    value: function Er() {
      return this.Br;
    }
  }, {
    key: "Gr",
    value: function Gr(t) {
      this.Br = t;
    }
  }, {
    key: "ds",
    value: function ds(t, e, s, i) {
      var r = new E();
      var n;

      if (e === d.Nr || t instanceof ControlMessage) {
        if (!t.wt()) return N.info("This in-app message has already received an impression. Ignoring analytics event."), r;
      } else if (e === d.Cr || t instanceof HtmlMessage && e === d.Or) {
        if (!t.rt(i)) return N.info("This in-app message has already received a click. Ignoring analytics event."), r;
      }

      return n = t instanceof ControlMessage ? {
        trigger_ids: [t.triggerId]
      } : this.Xr(t), null == n ? r : (t.messageExtras && (n.message_extras = t.messageExtras), null != s && (n.bid = s), c.ds(e, n));
    }
  }, {
    key: "Hr",
    value: function Hr(t, e) {
      var s = new E();
      if (!t.rt()) return N.info("This in-app message button has already received a click. Ignoring analytics event."), s;
      var i = this.Xr(e);
      return null == i ? s : t.id === InAppMessageButton.Jr ? (N.info("This in-app message button does not have a tracking id. Not logging event to Braze servers."), s) : (null != t.id && (i.bid = t.id), c.ds(d.Or, i));
    }
  }, {
    key: "Kr",
    value: function Kr(t) {
      var e = t.messageFields;
      return null != e && e.is_push_primer || !1;
    }
  }, {
    key: "Lr",
    value: function Lr(t) {
      if (!(t instanceof InAppMessage)) return;

      var e = function e(t) {
        if (!t) return;
        var e = eo(t);
        return ft(e) ? jt(vt.Qr, "In-App Message") : gt(e) && !yt.Ur() ? jt(vt.Vr, "In-App Message") : void 0;
      };

      if (this.Kr(t) && !yt.Ur()) return "In-App Message contains a push prompt, but is not eligible for a push prompt. Ignoring.";
      var s = t.buttons || [];
      var i;

      var _iterator = _createForOfIteratorHelper(s),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          if (_t.clickAction === InAppMessage.ClickAction.URI && _t.uri && to.test(_t.uri) && (i = e(_t.uri), i)) return i;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t.clickAction === InAppMessage.ClickAction.URI && t.uri && to.test(t.uri) ? e(t.uri) : void 0;
    }
  }, {
    key: "Wr",
    value: function Wr(t, e, s, i) {
      var _this = this;

      var r = this.S;
      if (!r) return;
      var n = r.Yr(!1, !1),
          o = r.H(n);
      o.template = {
        trigger_id: t.triggerId,
        trigger_event_type: e
      }, null != s && (o.template.data = s.Zr());
      var u = r.J(o, h.O.sn);
      r.V(o, function () {
        var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        if (!_this.S) return;
        var n = new Date().valueOf();
        h.W(_this.C, h.O.sn, n), -1 !== r && u.push(["X-Braze-Req-Tokens-Remaining", r.toString()]), l.Y({
          url: "".concat(_this.S.Z(), "/template/"),
          data: o,
          headers: u,
          ss: function ss(e) {
            if (h.ns(_this.C, h.O.sn, 1), !_this.S.ts(o, e, u)) return void ("function" == typeof t.on && t.on());
            if (_this.S.es(), null == e || null == e.templated_message) return;
            var s = e.templated_message;
            if (s.type !== pt.ln.an) return;
            var i = ut(s.data);
            if (null == i) return;

            var r = _this.Lr(i);

            if (r) return N.error(r), void ("function" == typeof t.on && t.on());
            "function" == typeof t.un && t.un(i);
          },
          error: function error(r) {
            var n = "getting user personalization for message ".concat(t.triggerId);

            if (new Date().valueOf() - t.pn < t.mn) {
              h.hs(_this.C, h.O.sn);

              var _r2 = Math.min(t.mn, _this.Tr),
                  _o = _this.Mr;

              null == i && (i = _o);

              var _l = Math.min(_r2, a(_o, 3 * i));

              n += ". Retrying in ".concat(_l, " ms"), setTimeout(function () {
                _this.Wr(t, e, s, _l);
              }, _l);
            }

            _this.S.rs(r, n);
          }
        });
      }, h.O.sn);
    }
  }, {
    key: "Xr",
    value: function Xr(t) {
      if (null == t.triggerId) return N.info("The in-app message has no analytics id. Not logging event to Braze servers."), null;
      var e = {};
      return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
    }
  }, {
    key: "Me",
    value: function Me(e) {
      return !!this.C && !(!(e && e instanceof InAppMessage && e.constructor !== InAppMessage) || e instanceof ControlMessage) && this.C.js(t.bs.cn, e.Bs());
    }
  }, {
    key: "Ar",
    value: function Ar() {
      if (!this.C) return null;
      var e = this.C.ps(t.bs.cn);
      if (!e) return null;
      var s;

      switch (e.type) {
        case InAppMessage.Qe.gn:
          s = FullScreenMessage.hn(e);
          break;

        case InAppMessage.Qe.fn:
        case InAppMessage.Qe.Le:
        case InAppMessage.Qe.Io:
          s = HtmlMessage.hn(e);
          break;

        case InAppMessage.Qe.dn:
        case InAppMessage.Qe.xo:
          s = ModalMessage.hn(e);
          break;

        case InAppMessage.Qe.jn:
          s = SlideUpMessage.hn(e);
      }

      return s && this.vn(), s;
    }
  }, {
    key: "vn",
    value: function vn() {
      this.C && this.C.Ls(t.bs.cn);
    }
  }]);

  return ea;
}();

export { ea as default };